import { Breadcrumb, ConfigProvider, Typography } from 'antd'
import useTranslation from '@/hooks/useTranslation'
import T from '@/components/common/T'

const { Title, Paragraph, Text } = Typography;

function AboutPage() {
    const { t } = useTranslation();

    return (
        <main>
            <section
                style={{
                    height: 200,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    flexDirection: "column",
                    backgroundColor: "#d5e8eb",
                    borderRadius: 8,
                    paddingBlock: 25,
                    paddingInline: 50,
                }}
            >
                <Title
                    level={2}
                    style={{
                        textTransform: "uppercase",
                        color: "#2e2525",
                        fontWeight: 600,
                        fontSize: 40,
                        marginBottom: 4,
                    }}
                >
                    <T k="about.title" />
                </Title>
                <Breadcrumb
                    separator=">"
                    style={{ fontSize: 20, fontWeight: 500 }}
                    items={[
                        { title: t("about.breadcrumb.home") },
                        { title: t("about.breadcrumb.title") },
                    ]}
                />
            </section>

            <section style={{ padding: "40px 50px" }}>
                <ConfigProvider
                    theme={{
                        token: {
                            fontSize: 16,
                            lineHeight: "1.2"
                        }
                    }}
                >
                    <Paragraph>
                        <T k="about.p1_before" />{" "}
                        <Text style={{ fontWeight: 700 }}><T k="about.p1_bold" /></Text>
                        <T k="about.p1_after" />
                    </Paragraph>
                    <Paragraph><T k="about.p2" /></Paragraph>
                    <Paragraph><T k="about.p3" /></Paragraph>
                    <Paragraph style={{ marginBottom: 0 }}><T k="about.p4" /></Paragraph>
                    <Paragraph><T k="about.p5" /></Paragraph>
                    <Paragraph><T k="about.p6" /></Paragraph>
                    <Paragraph><T k="about.p7" /></Paragraph>
                    <Paragraph style={{ marginBottom: 0 }}><T k="about.p8" /></Paragraph>
                    <Paragraph style={{ marginBottom: 0 }}><T k="about.p9" /></Paragraph>
                    <Paragraph><T k="about.p10" /></Paragraph>
                    <Paragraph><T k="about.p11" /></Paragraph>
                    <Paragraph><T k="about.p12" /></Paragraph>
                    <Paragraph><T k="about.p13" /></Paragraph>
                    <Paragraph><T k="about.p14" /></Paragraph>
                    <Paragraph style={{ marginBottom: 0 }}><T k="about.p15" /></Paragraph>
                    <Paragraph><T k="about.p16" /></Paragraph>
                    <Paragraph style={{ marginBottom: 0 }}><T k="about.p17" /></Paragraph>
                    <Paragraph><T k="about.p18" /></Paragraph>
                </ConfigProvider>
            </section>
        </main>
    )
}

export default AboutPage
